import { Route } from 'react-router-dom'
import * as React from 'react'

/**
 * @description Route 高阶组件，用于封装 react-router 的 Route 组件
 * @example
 * @RouteWrapper('/demo', {exact: true})
 * export default class Demo {}
 * @param path Route 组件路径
 * @param option Route 组件其他配置项，详见 react-router 文档
 */
const RouteWrapper = (path: string, option?: any) => (
  Component: new (...args: any[]) => React.Component<any>,
) => (): React.ReactElement<any> => (
  <Route path={path} {...option} render={props => <Component {...props} />} />
)

export default RouteWrapper
